import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { KpiReportFilter } from 'src/app/common/dtos/reports.dto';
import { APICoreService } from 'src/app/common/services/api-core/api-core.service';

@Injectable({
  providedIn: 'root',
})
export class ReportingPlansService {
  constructor(private apiService: APICoreService) {}

  getPlans(
    filters: KpiReportFilter[],
    page = 1,
    per_page = 10,
    report = 'implementationPlan',
    reportFiltersetId?: number | null
  ) {
    const params: Record<string, unknown> = {
      measure: { type: 'count', field: '*' },
      page,
      per_page,
      report,
    };
    if (reportFiltersetId) {
      params['report_filterset_id'] = reportFiltersetId;
    } else {
      params['filters'] = filters;
    }
    return this.apiService.getRequest('reporting/load-report', params);
  }

  queueDownloadReport(
    filters: KpiReportFilter[],
    report?: { title: string; report: string }
  ) {
    const params = {
      report_title: 'Implementation Plan',
      report: 'implementationPlan',
      filters,
    };

    if (report) {
      params.report_title = report.title;
      params.report = report.report;
    }

    return this.apiService
      .postRequest('reporting/queue-report-download', params)
      .pipe(map((res: boolean) => res));
  }
}
